export class GoogleAnalytics {
  constructor(coursenum, isAuthenticated, trackingId, highestRole) {
    this.coursenum = coursenum
    this.isAuthenticated = isAuthenticated
    this.trackingId = trackingId
    this.highestRole = highestRole
  }

  attach() {
    /* eslint-disable */
    ;(function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r
      ;(i[r] =
        i[r] ||
        function () {
          ;(i[r].q = i[r].q || []).push(arguments)
        }),
        (i[r].l = 1 * new Date())
      ;(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0])
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(
      window,
      document,
      'script',
      'https://www.google-analytics.com/analytics.js',
      'ga'
    )
    /* eslint-enable */
    ga('create', 'UA-75302968-1', 'auto')

    // See our custom dimensions in analytics.google.com
    if (this.coursenum) {
      ga('set', 'dimension2', this.coursenum)
      if (this.is_authenticated) {
        ga('set', 'dimension1', this.highest_role)
      }
    }

    ga('send', 'pageview')

    // Tracking by host
    if (this.trackingId) {
      ga('create', this.trackingId, 'auto', 'hostTracker')
      ga('hostTracker.send', 'pageview')
    }
  }
}
